var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-settings-popup", {
    attrs: {
      "is-new": _vm.isNew,
      invalid: _vm.$v.$invalid,
      resources: {
        deletePromptTitle: _vm.resource("JourneyBuilder_Filter_Delete_Title"),
        deletePromptBody: _vm.resource("JourneyBuilder_Filter_Delete_Body"),
        deleteButtonText: _vm.resource(
          "JourneyComposer_FilterModal_Button_DeleteCheckpoint"
        )
      },
      "comment-id": _vm.commentId
    },
    on: {
      save: function($event) {
        return _vm.saveConnection()
      },
      delete: function($event) {
        return _vm.deleteCheckpoint()
      },
      "display-errors": function($event) {
        return _vm.displayErrors()
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("div", { staticClass: "w-100" }, [
              _c("h3", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.resource("JourneyComposer_FilterModal_Title")) +
                    "\n            "
                )
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c(
              "h4",
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.resource(
                        "JourneyComposer_FilterModal_CustomConditionsTitle"
                      )
                    ) +
                    "\n            "
                ),
                _c("help-popover", {
                  attrs: {
                    title: _vm.resource(
                      "JourneyComposer_FilterModal_CustomConditionsTitle"
                    ),
                    content: _vm.resource(
                      "JourneyComposer_FilterModal_CustomConditions"
                    )
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("brick-filter-settings-editor", {
              ref: "editor",
              attrs: {
                conditions: _vm.conditionsModel,
                "excluded-category-filters": ["Audience", "NotAudience"]
              },
              on: {
                "conditions-changed": function($event) {
                  _vm.conditionsModel = $event
                },
                "validation-state-changed": function($event) {
                  _vm.conditionsValid = $event
                }
              }
            }),
            _vm._v(" "),
            !_vm.$v.conditionsModel.required
              ? _c("error-message", {
                  attrs: {
                    message: _vm.resource(
                      "JourneyComposer_GroupRequired_ErrorMessage"
                    )
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }